import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import React, { useEffect, useState } from "react";
import ReactOwlCarousel from 'react-owl-carousel';
import { useApp } from "../../context/AppContextProvider";
import { enviroment } from "../../enviroment";
import ApiService from "../../services/ApiService";
import { ProductCard } from "../ProductCard/ProductCard";

export const NewArrival = () => {
    const appData = useApp();
    const { windowWidth } = appData.appData;
    const [productData, setProductData] = useState([]);
    const isMobile = windowWidth === "mobile";

    useEffect(() => {
        const fetchNewArrivals = async () => {
            try {
                const payload = {
                    store_id: parseInt(enviroment.STORE_ID)
                };
                const res = await ApiService.newArrivals(payload);
                setProductData(res.payload_newarrivalRandom || []);
            } catch (err) {
                console.error('Error fetching new arrivals:', err);
            }
        };
        fetchNewArrivals();
    }, []);

    if(!productData || productData?.length === 0) {
        return null;
    }

    const carouselOptions = {
        margin: isMobile ? 10 : 20,
        dots: false,
        nav: true,
        loop: productData.length > (isMobile ? 1 : 4),
        items: isMobile ? 1 : 4,
        stagePadding: isMobile ? 40 : 0,
        responsive: {
            0: { items: 1.5, stagePadding: 40 },
            576: { items: 2, stagePadding: 30 },
            768: { items: 3, stagePadding: 20 },
            992: { items: 3, stagePadding: 0 },
            1200: { items: 4, stagePadding: 0 }
        },
        touchDrag: true,
        mouseDrag: true,
        smartSpeed: 750,
    };

    return (
        <div style={{ marginTop: '3rem', position: 'relative' }}>
            {productData.length > 0 && (
                <div className={`col-12 ${windowWidth === "desktop" ? 'px-3' : 'px-0'}`}>
                    <div className="container">
                        <div className="col-12 d-flex flex-column">
                            <div className="titlesWrapper">
                                <p className="subTitleLarge">What's Hot</p>
                            </div>
                            <div style={{ position: 'relative', padding: '0' }}>
                                <ReactOwlCarousel
                                    className="owl-theme"
                                    {...carouselOptions}
                                >
                                    {productData
                                        .sort((a, b) => b.stock - a.stock)
                                        .map((item, index) => (
                                            <div
                                                key={index}
                                                className="item"
                                                style={{
                                                    padding: '20px 10px',
                                                    transition: 'transform 0.3s ease',
                                                    cursor: 'pointer',
                                                    zIndex: 1
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = "scale(1.03)";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = "scale(1)";
                                                }}
                                            >
                                                <ProductCard item={item} index={index} />
                                            </div>
                                        ))}
                                </ReactOwlCarousel>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <style jsx>{`
                .owl-nav {
                    position: absolute;
                    top: 50%;
                    width: 100%;
                    transform: translateY(-50%);
                    display: flex;
                    justify-content: space-between;
                    pointer-events: none;
                }
                .owl-nav button {
                    pointer-events: auto;
                    background: rgba(255, 255, 255, 0.8) !important;
                    padding: 0px !important;
                    width: 45px !important;
                    height: 45px !important;
                    border-radius: 100% !important;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
                    transition: all 0.3s ease;
                }
                @media (max-width: 576px) {
                    .owl-prev {
                        margin-left: -20px;
                    }
                    .owl-next {
                        margin-right: -20px;
                    }
                }
            `}</style>
        </div>
    );
};